








































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";


export default Vue.extend({
    components: {
        iwModal: iwModal
    },

    computed: {
        isResetWizardModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isResetWizardModalOpen"];
        },
        fieldToTranslate: function(): string {
            return this.$store.getters["ResetWizardModule/getField"];
        }
    },

    methods: {
        closeResetWizardModal: function() {
            this.$store.commit("ModalModule/closeResetWizardModal");
        },
        applyChange: function() {
            this.$store.commit("ResetWizardModule/setApplyChange", true);
            this.closeResetWizardModal();
        }
    }
});

